module.exports = __webpack_public_path__ + "img/seandaily.3ee8b4a7.jpeg";